import { render, staticRenderFns } from "./VehicleTypeComponent.vue?vue&type=template&id=2048ca2e&"
import script from "./VehicleTypeComponent.vue?vue&type=script&lang=js&"
export * from "./VehicleTypeComponent.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTypeComponent.vue?vue&type=style&index=0&id=2048ca2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports